/*


Creek.audio.play()

Play the current audio type.


CreekAudioToolbar.play()

Toolbar plays whatever the current type is now. Live or File.

If live, then play live.
If file, then:
- Play file.
- Show the seek bar, seek position time, and total duration.
- Show the 
- Add the content.URL, so that you can click on it.

In AudioPlayer, if  browsing the website, if you come across a player with the same media_id as the current file, then it will use the same attributes from Creek.audio.file.

Audio players play specific file audio.

On page load, it should play stream.

---------------------------

TODO:

- Handle multiple media on Broadcast page.
- More consistent usage of the universal "API" object.
- PlayerMini and Player need a clear way of handling single vs. multiple audio files.


- "url" in API v2 should be "URL".

- typeResolved is a dumb name.

- Is audio.file.URL even used? Remove it if not needed? It's already at API.media.meta.url.

- Make the API parameter handling more solid. ALl forms of play expect an API state to be given to it, either to compare with the global API state, in order to play a new file or stream, or to just not take action if it's the same.

- Use API parameter for live stream, too

- Position should be under audio.file.playStatus: { ID: 123, position: 456 }

- Simple way to make sure that current position is a certain file in view? computed: CurrentAudio: add playStatus object?

- If file not loaded and click seek bar: "Uncaught TypeError: Cannot read property 'seek' of null"

- AudioToolbar: make track clickable and use Broadcast URL if available -- make sure Broadcast is included in API data

- AudioToolbar: Use Tracks API v2 in Broadcasting data -- but this means changing Live API

- remove all of the console.log's

- move the KWMR-specific colors into a "dark" theme file (since they are mostly white on black).

- social buttons -> Vue

- get the position faster, on load, not after 1 second

- show loading icon on mini broadcast player

- volume bar acts stupid

- "next broadcast" button on broadcasts

- makeit more clear that it only says "read more" if there is text. test this, and show example
- Example: http://localhost:8080/#/shows/classical-thursday

- go to broadcast page on listen click

- cache API data, so that back button is faster

- make broadcast titles smaller

- DJ pages

- Do something interesting when file ends

- Make sure that Live is totally reloaded on switch from file to live. It got stuck in loading, nonplaying, state.

*/

import CreekAudioPlayer from '../components/AudioPlayer';
import CreekAudioToolbar from '../components/AudioToolbar';
import CreekAudioToolbarVolume from '../components/AudioToolbarVolume';

import Howler from 'howler';

var Howl = Howler.Howl;

const CreekAudioPlugin = {
  install(Vue, options) {

    if(options.globalVar){
      var _scope = options.globalVar;
    }else{
      var _scope = window.top.document;
    }

    // /*
    // // TODO: Make sure that iframe persistence works with this scope.
    // */
    // if(options.persist && options.persist == "iframe"){
    //   _scope = window.top.document;
    // }

    _scope.Creek.audio = {
      
      // Default to Live
      type: "live",
      // type: null,

      volume: 1.0,
      state: null,
      updateRate: 1000,

      playable: null,

      //-----------------------------------------------
      // Global functions
      //-----------------------------------------------

      toggle(API, type) {
        type = type || _scope.Creek.audio.type; 
        _scope.Creek.debug.log("Audio: Global: Attempting to toggle "+type+".");
        if(_scope.Creek.audio[type].player === null || !_scope.Creek.audio[type].player.playing()){
          _scope.Creek.audio[type].play(API);
        }
        else{
          _scope.Creek.audio[type].stop();
        }
      },
      
      play(API, type) {
        var typeResolved = type || _scope.Creek.audio.type;
        if(typeResolved){
          _scope.Creek.audio.type = typeResolved;
        }
        _scope.Creek.debug.log("Audio: Global: Attempting to play "+typeResolved+".");
        _scope.Creek.audio[typeResolved].play(API);
      },

      stop() {
        var type = _scope.Creek.audio.type;
        _scope.Creek.debug.log("Audio: Global: Attempting to stop "+_scope.Creek.audio.type+".");
        _scope.Creek.audio[type].stop();
      },
      
      volume(amount) {
        
        var type = _scope.Creek.audio.type;

        // console.log(amount);
        // console.log(_scope.Creek.audio[type].player);

        // Set volume
        if(
          typeof amount != "undefined" 
          && amount !== null 
          && _scope.Creek.audio[type].player !== null
        ){
          _scope.Creek.debug.log("Audio: Global: Attempting to change volume of "+type+" to: "+amount);
          _scope.Creek.audio[type].player.volume(amount);
          return _scope.Creek.audio[type].player.volume();
        }
        // Get volume
        else if(_scope.Creek.audio[type].player !== null){
          _scope.Creek.debug.log("Audio: Global: Attempting to get volume of "+type+": "+_scope.Creek.audio[type].player.volume());
          return _scope.Creek.audio[type].player.volume();
        }
        
        return null;

      },

      seek(position) {
        var type = _scope.Creek.audio.type;
        // console.log(amount);
        // console.log(_scope.Creek.audio[type].player);
        if(typeof position != "undefined" && position !== null && _scope.Creek.audio[type].player !== null){
          _scope.Creek.debug.log("Audio: Global: Attempting to change seek position of "+type+" to: "+position);
          _scope.Creek.audio[type].player.volume(amount);
        }
        else{
          _scope.Creek.debug.log("Audio: Global: Attempting to get seek position of "+type+": "+_scope.Creek.audio[type].player.seek());
        }
        return _scope.Creek.audio[type].player.seek() || null;
      },

      timeFormat(seconds) {
        
        // seconds == seconds || 0;

        // console.log(seconds);

        if(!seconds === null || typeof seconds == "object"){
          seconds = 0;
        }

        var date = new Date(null);
        date.setSeconds(seconds);
        var time = date.toISOString().substr(11, 8);
        var timeTrimmed = time;
        var trimLimit = 0;

        // Remove leading zeroes
        while((timeTrimmed.substr(0,1) == '0' || timeTrimmed.substr(0,1) == ':') && trimLimit <= 3){
          timeTrimmed = timeTrimmed.slice(1);
          trimLimit++;
        }
        
        return timeTrimmed;
      
      },

      setStateAndPlayable(type, state, playable){
        _scope.Creek.audio[type].state = state;
        _scope.Creek.audio[type].playable = playable;
        _scope.Creek.audio.state = state;
        _scope.Creek.audio.playable = playable;
      },

      //-----------------------------------------------
      // File and Live: Players and functions
      //-----------------------------------------------

      file: {
        type: "file",
        player: null, // Howler audio player instance.
        URL: null,
        position: null,
        positionFormatted: null,
        duration: null,
        durationFormatted: null,
        state: null,
        content: {
          URL: null
        },
        API: {
          Broadcast: null,
          Show: null,
          Track: null,
          Media: null,
        },
        play(API){ 

          _scope.Creek.debug.log("Audio [file]: Attempting to play.");

          var URL = API.Media.meta.url || null;

          // Switch to file, stopping live player if necessary.
          _scope.Creek.audio.file.switch();

          _scope.Creek.audio.file.API = API;
          _scope.Creek.audio.file.URL = URL;

          _scope.Creek.debug.log("Audio [file]: Selected:");
          _scope.Creek.debug.log(URL);
          _scope.Creek.debug.log(API);

          // Set state to loading.
          _scope.Creek.audio.file.setLoading();

          // Don't unload the file player, so that position is maintained.
          // _scope.Creek.audio.file.player.unload();
          // _scope.Creek.audio.file.player.stop();

          //---------------------
          // Play file player
          //---------------------

          // If not initialized, then do so, and play.
          if(_scope.Creek.audio.file.player === null){

            _scope.Creek.audio.init("file", _scope.Creek.audio.file.URL);
            
            // Play
            _scope.Creek.audio.file.player.play();

          }
          // If different file, then unload and init as different file, and play.
          else if(_scope.Creek.audio.file.player !== null && _scope.Creek.audio.file.player._src != URL){
            _scope.Creek.debug.log("Switching audio file.");
            _scope.Creek.debug.log("Previous URL: " + _scope.Creek.audio.file.player._src);
            _scope.Creek.debug.log("New URL: " + URL);
            _scope.Creek.audio.file.player.unload();
            _scope.Creek.audio.init("file", URL);
            _scope.Creek.audio.file.player.play();
          }
          // If same file, and already loaded, then just play.
          else{
            _scope.Creek.audio.file.player.play();
          }

          // Delete the interval
          if(_scope.Creek.audio.file.positionUpdateInterval !== null){
            clearInterval(_scope.Creek.audio.file.positionUpdateInterval);
          }

          // Update seek data now
          // _scope.Creek.audio.file.updateSeek();

          // Start position updater interval.
          _scope.Creek.audio.file.positionUpdateInterval = setInterval(
            _scope.Creek.audio.file.updateSeek,
            _scope.Creek.audio.updateRate,
          );

        },
        stop(){
          _scope.Creek.audio.type = "file";
          if(_scope.Creek.audio.file.player !== null){
            
            _scope.Creek.audio.file.player.pause();

            // Delete the position interval
            if(_scope.Creek.audio.file.positionUpdateInterval !== null){
              clearInterval(_scope.Creek.audio.file.positionUpdateInterval);
            }

          }
        },
        toggle(API) {
          
          _scope.Creek.debug.log("Toggling file play.");
          
          _scope.Creek.debug.log("API data: ");
          _scope.Creek.debug.log(API);

          // Switch to file, stopping live if necessary.
          _scope.Creek.audio.file.switch();

          // Set up URL from API data, if available.
          var URL = API.Media.meta.url || null;
          
          _scope.Creek.debug.log("Toggling with URL: "+ URL);

          // Add data to global audio state
          _scope.Creek.audio.file.API = API;
          _scope.Creek.audio.file.URL = URL;

          /*
          -------------------------------
          
          Toggle Logic
          
          NOTE: Some of this overlaps with Creek.audio.file.play() 
          since toogle includes the "stop" functionality, and at this level, 
          it may change the file URL and necessitate re-initialization of 
          the new file in same conditional.
          
          -------------------------------
          */

          // If not initialized yet, then play (which handles initializing).
          // - Use MAIN "Creek.audio.play" method so that it switches to the file if playing stream.
          if(_scope.Creek.audio.file.player === null){
            _scope.Creek.audio.file.play(API);
          }
          // If initialized, and it's a new file (different URL),
          // then switch to new file and (always) start playing.
          // (Always: since every button starts out as a play button.)
          else if(_scope.Creek.audio.file.player._src != URL){
            _scope.Creek.debug.log("Switching audio file.");
            _scope.Creek.debug.log("Previous URL: " + _scope.Creek.audio.file.player._src);
            _scope.Creek.debug.log("New URL: " + URL);
            _scope.Creek.audio.file.player.unload();
            _scope.Creek.audio.init("file", URL);
            _scope.Creek.audio.file.player.play();
          }
          // If initialized, and same file, but not playing, then play.
          else if(!_scope.Creek.audio.file.player.playing()){
            _scope.Creek.audio.file.play(API);
          }
          // If initialized, and same file, and playing, then stop.
          else if(_scope.Creek.audio.file.player.playing()){
            _scope.Creek.debug.log("Stopping file (or live) globally.");
            _scope.Creek.audio.file.stop();
          }
          // Else, some kind of bug in the conditionals above...
          else{
            _scope.Creek.debug.log('ERROR: Could not play file. Player initialized, but no ".playing()" function present.');
          }

        },
        switch(){
          if(_scope.Creek.audio.live.player !== null){
            _scope.Creek.audio.live.player.stop();
          }
          _scope.Creek.audio.type = "file";
        },
        // We need a special function for the loading state, 
        // since the audio player is not initialized yet.
        setLoading(){
          _scope.Creek.audio.setStateAndPlayable("file", "loading", false);
        },
        updateSeek(){

          if(_scope.Creek.audio.file.player === null){
            _scope.Creek.audio.file.position = null;
            _scope.Creek.audio.file.duration = null;
            return null;
          }
          else {
            _scope.Creek.audio.file.position = _scope.Creek.audio.file.player.seek() || null;
            _scope.Creek.audio.file.duration = _scope.Creek.audio.file.player.duration() || null;
          }

          _scope.Creek.audio.file.positionFormatted = _scope.Creek.audio.timeFormat(_scope.Creek.audio.file.position);
          _scope.Creek.audio.file.durationFormatted = _scope.Creek.audio.timeFormat(_scope.Creek.audio.file.duration);

          _scope.Creek.debug.log("Audio [file]: Position: " + _scope.Creek.audio.file.positionFormatted + " / " + _scope.Creek.audio.file.durationFormatted);
          
        },
        seek(position) {
          var type = _scope.Creek.audio.type;
          // console.log(amount);
          // console.log(_scope.Creek.audio[type].player);
          if(typeof position != "undefined" && position !== null && _scope.Creek.audio[type].player !== null){
            _scope.Creek.debug.log("Audio: Global: Attempting to change seek position of "+type+" to: "+position);
            _scope.Creek.audio[type].player.volume(amount);
          }
          else{
            _scope.Creek.debug.log("Audio: Global: Attempting to get seek position of "+type+": "+_scope.Creek.audio[type].player.seek());
          }
          return _scope.Creek.audio[type].player.seek();
        }, 
        positionUpdateInterval: null,
      },

      live: {
        type: "live",
        player: null, // Howler audio player instance.
        URL: null,
        state: null,
        playable: null,
        play(){ 
          
          _scope.Creek.debug.log("Audio [live]: Attempting to play.");

          // Switch to live, stopping the file player if needed.
          _scope.Creek.audio.live.switch();

          // Set state to loading.
          _scope.Creek.audio.live.setLoading();

          // _scope.Creek.debug.log("Audio [live]: Selected:");
          // _scope.Creek.debug.log(URL);
          // _scope.Creek.debug.log(API);

          //---------------------
          // Play live player
          //---------------------

          // Initialize if needed.
          if(_scope.Creek.audio.live.player === null){

            // - Init if URL of live stream.
            if(_scope.Creek.audio.live.URL){
            
              _scope.Creek.audio.init("live", _scope.Creek.audio.live.URL);
            
              // Play
              _scope.Creek.audio.live.player.play();
            
            }
            // - Don't init if no URL of live stream.
            else {
              _scope.Creek.debug.log("Audio [live]: Needs URL to play.");
            }

          }
          else{
            _scope.Creek.audio.live.player.play();
          }

          // File: Delete the position-checking interval for file
          if(_scope.Creek.audio.file.positionUpdateInterval !== null){
            clearInterval(_scope.Creek.audio.file.positionUpdateInterval);
          }

        },
        stop(){ 
          if(_scope.Creek.audio.live.player){
            _scope.Creek.audio.live.player.stop();
            _scope.Creek.audio.live.player.unload();
          }
        },
        toggle(API) {
          var URL = API.Stream.attributes.URL || null;
          if(URL){
            _scope.Creek.audio.live.URL = URL;
          }
          _scope.Creek.audio.type = "live";
          _scope.Creek.audio.toggle(API);
        },
        switch(play){
          
          play = play || false;

          if(_scope.Creek.audio.file.player !== null){
            _scope.Creek.audio.file.player.stop();
          }
          
          _scope.Creek.audio.type = "live";

          if(play){
            _scope.Creek.audio.live.play();
          }

        },
        setLoading(){
          _scope.Creek.audio.setStateAndPlayable("live", "loading", false);
        },
        content: {
          URL: null
        },
        API: {
          Broadcast: null,
          Show: null,
          Track: null,
          Media: null,
        }
      },

    }

    _scope.Creek.audio.init = (type, initialAudioURL) => { 

      _scope.Creek.debug.log("Audio ["+type+"]: Initializing audio: "+initialAudioURL);

      // var autoplay = autoplay || false;

      var player = new Howl({

        src: [ initialAudioURL ],
        
        volume: 1,
        // autoplay: true,
        // autoplay: autoplay,
        html5: true,

        // ext: ['mp3'],
      
      })
      // Events:
      .on("load", (x) => {
        _scope.Creek.debug.log("Audio: "+type+": Loaded and playing.");
        _scope.Creek.audio.setStateAndPlayable(type, "loaded", true);
      })
      .on("loaderror", (x) => {
        _scope.Creek.debug.log("Audio: "+type+": Could not load file:");
        _scope.Creek.audio.setStateAndPlayable(type, "loaderror", true);
      })
      .on("play", () => {
        _scope.Creek.debug.log("Audio: "+type+": Playing.");
        _scope.Creek.audio.file.updateSeek();
        _scope.Creek.audio.setStateAndPlayable(type, "playing", false);
      })
      .on("playerror", () => {
        _scope.Creek.debug.log("Audio: "+type+": Error while playing.");
        _scope.Creek.audio.setStateAndPlayable(type, "playerror", true);
      })
      .on("seek", () => {
        _scope.Creek.debug.log("Audio: "+type+": Seeking.");
        _scope.Creek.audio[type].position = _scope.Creek.audio[type].player.seek();
        _scope.Creek.audio.file.updateSeek();
        _scope.Creek.audio.setStateAndPlayable(type, "playing", false);
      })
      .on("pause", () => {
        _scope.Creek.debug.log("Audio: "+type+": Paused.");
        _scope.Creek.audio.setStateAndPlayable(type, "paused", true);
      })
      .on("resume", () => {
        _scope.Creek.debug.log("Audio: "+type+": Resume.");
        _scope.Creek.audio.setStateAndPlayable(type, "playing", false);
      })
      .on("stop", () => {   
        _scope.Creek.debug.log("Audio: "+type+": Stopped.");
        _scope.Creek.audio.setStateAndPlayable(type, "stopped", true);
      })
      .on("end", () => {
        _scope.Creek.debug.log("Audio: "+type+": Ended.");
        _scope.Creek.audio.setStateAndPlayable(type, "ended", true);
      })
      .on("volume", (x, y) => {
        _scope.Creek.debug.log("Audio: "+type+": Volume change.");
      })
      .on("fade", () => {
        // not used
      })
      .on("rate", () => {
        // not used
      })

      // Add player to global object for all Vue instances.
      _scope.Creek.audio[type].player = player;

    }

    // Add the other components
    Vue.component(CreekAudioPlayer.name, CreekAudioPlayer)
    Vue.component(CreekAudioToolbar.name, CreekAudioToolbar)

    Vue.prototype.Creek.audio = _scope.Creek.audio;

  }
};

export default CreekAudioPlugin;



//   computed: {
//     audio: {
//       currentTrack() {

//         // If File, then check for position within 
      
//         // If Live, then use API.Broadcasting

//       },

//     }
//   },

